import api from '@/api'
export default {
  async reloadCompanyInfo({ state, commit }, params = {}) {
    await api.getCompany(params).then(res => {
      commit('setCompanyInfo', res.data || {})
    })
  }
}
